import React from 'react';
import { Typography, useTheme } from '@mui/material';

export const FlickeringBeta = () => {
  const theme = useTheme();

  return (
    <>
      {/* <Typography
        position="absolute"
        data-text="U"
        letterSpacing={4}
        variant="body1"
        zIndex={1}
        sx={{
          left: { xs: 60, sm: 90, md: 120 },
          textShadow: `
          1px 0px 4px ${theme.palette.primary.light}, 
          2px 0px 4px ${theme.palette.primary.light}, 
          3px 0px 4px ${theme.palette.primary.light},
          2px 0px 3px ${theme.palette.primary.light}, 
          2px 3px 15px ${theme.palette.primary.light}, 
          2px 0px 15px, 5px 0px 125px,
          20px 0vw 200px ${theme.palette.primary.light}, 
          40px 0vw 200px ${theme.palette.primary.light};`,
          top: 0,
        }}
      >
        open
      </Typography> */}
      <Typography
        data-text="U"
        letterSpacing={4}
        variant="h6"
        zIndex={1}
        sx={{
          // left: { xs: 120, sm: 150, md: 180 }, for open beta
          left: { xs: 80, sm: 130, md: 170 },
          textShadow: `
    1px 0px 4px ${theme.palette.primary.light}, 
    2px 0px 4px ${theme.palette.primary.light}, 
    3px 0px 4px ${theme.palette.primary.light},
    2px 0px 3px ${theme.palette.primary.light}, 
    2px 3px 15px ${theme.palette.primary.light}, 
    2px 0px 15px, 5px 0px 125px,
    20px 0vw 200px ${theme.palette.primary.light}, 
    40px 0vw 200px ${theme.palette.primary.light};`,
          top: 0,
        }}
      >
        B<span className="flicker-slow">E</span>T
        <span className="flicker-fast">A</span>
      </Typography>
    </>
  );
};
